import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type BasicTooltip from "cc-frontend/services/basic-tooltip"

export default class BasicTooltipComponent extends Component {
  @service declare basicTooltip: BasicTooltip
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    BasicTooltipComponent: typeof BasicTooltipComponent
  }
}
